// ============================================================================
// page-service-single / form.js
// ----------------------------------------------------------------------------
// Populate the CF7 hidden `#from-page` field with the current service title
// so each consultation lead carries which service it came from.
//
// This template's hero uses `.service-hero__title` (correct class — matches
// what the inline JS in code block #105 was already querying).
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const fromPageInput = document.querySelector("#from-page");
  const heroTitle = document.querySelector(".service-hero__title");

  if (!fromPageInput || !heroTitle) return;

  fromPageInput.value = heroTitle.innerText.trim();
});
